import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGripVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3333 9.66667C12.3333 10.1269 12.7064 10.5 13.1667 10.5C13.6269 10.5 14 10.1269 14 9.66667C14 9.20643 13.6269 8.83333 13.1667 8.83333C12.7064 8.83333 12.3333 9.20643 12.3333 9.66667Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3333 15.5C12.3333 15.9602 12.7064 16.3333 13.1667 16.3333C13.6269 16.3333 14 15.9602 14 15.5C14 15.0398 13.6269 14.6667 13.1667 14.6667C12.7064 14.6667 12.3333 15.0398 12.3333 15.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3333 3.83333C12.3333 4.29357 12.7064 4.66667 13.1667 4.66667C13.6269 4.66667 14 4.29357 14 3.83333C14 3.3731 13.6269 3 13.1667 3C12.7064 3 12.3333 3.3731 12.3333 3.83333Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.33333 9.66667C6.33333 10.1269 6.70643 10.5 7.16667 10.5C7.6269 10.5 8 10.1269 8 9.66667C8 9.20643 7.6269 8.83333 7.16667 8.83333C6.70643 8.83333 6.33333 9.20643 6.33333 9.66667Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.33333 15.5C6.33333 15.9602 6.70643 16.3333 7.16667 16.3333C7.6269 16.3333 8 15.9602 8 15.5C8 15.0398 7.6269 14.6667 7.16667 14.6667C6.70643 14.6667 6.33333 15.0398 6.33333 15.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.33333 3.83333C6.33333 4.29357 6.70643 4.66667 7.16667 4.66667C7.6269 4.66667 8 4.29357 8 3.83333C8 3.3731 7.6269 3 7.16667 3C6.70643 3 6.33333 3.3731 6.33333 3.83333Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGripVertical;
